import { createInfiniteHitsSessionStorageCache } from "instantsearch.js/es/lib/infiniteHitsCache/index";

export const sessionStorageCache = createInfiniteHitsSessionStorageCache();
